import MovieCard from '@/components/base/MovieCard';
import type { Movie } from '@/mocks/movies';

interface MovieGridProps {
  title: string;
  subtitle?: string;
  movies: Movie[];
}

export default function MovieGrid({ title, subtitle, movies }: MovieGridProps) {
  return (
    <section>
      <div className="flex items-end justify-between mb-5">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-100">{title}</h2>
          {subtitle && <p className="text-sm text-foreground-400 mt-1">{subtitle}</p>}
        </div>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
        {movies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} variant="poster" />
        ))}
      </div>
    </section>
  );
}